import validator from 'validator';
import { PushNotificationPageData } from '../utils/pageContent';

function AddPushNotificationVali(data, selectedEmailList) {
  const errors = {};
  const messages = PushNotificationPageData.addPushNotificationPageData.validationMessages;

  if (validator.isEmpty(data.title.trim())) errors.title = messages.enterTitleErrorMessage;
  if (validator.isEmpty(data.message.trim())) errors.message = messages.enterMessageErrorMessage;

  if (data?.sentToUser === 4) {
    if (selectedEmailList?.length === 0) errors.email_ids = messages.selectEmailErrorMessage;
  }
  if (!data?.sentToUser && !data?.sentToDepartment) {
    errors.sent_to_user = messages.selectAtLeastOneUserErrorMessage;
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddPushNotificationVali;
